import { apiClient } from '_app'
import { ApiResponse, VehicleRecallRepairStatusDto } from 'dtos'

export const getVehicleRecallRepairStatuses = () =>
  apiClient
    .get<ApiResponse<VehicleRecallRepairStatusDto[]>>('/api/vehicle-recall-repair-statuses')
    .then(response => response.data)
